<template>
  <div>
    <div :class="getTabClass('cash')" @click="emitSwitch('cash')">
      {{ $t('archive.tabs.cash') }}
      <!-- <span class="amount" v-if="counters.cash > 0">{{ counters.cash }}</span> -->
    </div>
    <div :class="getTabClass('card')" @click="emitSwitch('card')">
      {{ $t('archive.tabs.card') }}
      <!-- <span class="amount grey" v-if="counters.card > 0">{{ counters.card }}</span> -->
    </div>
    <div :class="getTabClass('online')" @click="emitSwitch('online')">
      {{ $t('archive.tabs.online') }}
      <!-- <span class="amount" v-if="counters.online > 0">{{ counters.online }}</span> -->
    </div>
  </div>
</template>

<style scoped>

@media screen and (max-width:350px) {
  .tab {
    text-align: center;
    margin: 10px 5px !important;
    padding: 7px 15px 9px !important;
  }
  .amount {
    left: 20px !important;
    bottom: 15px !important;
  }
}

.tab {
  border-radius: 20px;
  box-shadow: 0px 3px 10px #e0e0e0;
  background: white;
  padding: 8px 20px;
  font-size: 14px;
  margin: 20px 5px;
  display: inline-block;
  transition: 0.3s;
}

.active {
  background: black;
  color: white;
  cursor: pointer;
}

.amount {
  position: relative;
  background: #ff5353;
  border-radius: 50px;
  padding: 3px 9px 4px;
  bottom: 20px;
  font-size:13px;
  margin-left: -25px;
  left: 25px;
  color: white;
}

.amount.grey {
  background: #616161;
}

</style>


<script>
export default {
    props: {
        currentTab: String,
        counters: Object
    },
    methods: {
        emitSwitch(nt) {
            this.$emit('switch', nt);
        },
        getTabClass(tab) {
            return {
                tab: true,
                active: this.currentTab === tab
            }
        }
    }
};
</script>
